import styled from 'styled-components';
import { fontSize, screen } from 'theme';

const Root = styled.div`
  background: #fff;
  border-radius: 25px;
  padding: 2rem;
  margin: 1rem;
  position: relative;
  margin-top: 2rem;

  .phoneNumber {
  }

  .half {
    flex-basis: 50%;
  }

  form {
    margin: auto;
    max-width: 40rem;
  }

  a {
    color: #097273;
  }

  @media (min-width: ${screen('lg')}) {
    background: url('/images/contact/contact-form-bg.svg') no-repeat top center;
    background-size: contain;
    margin: 0 0 2rem 0;
    border-radius: 0;
    padding: 4rem 0;
    margin-top: 4rem;
  }
`;

const Intro = styled.div`
  margin-bottom: 3rem;

  h1 {
    margin-top: 0;
    font-size: ${fontSize('xl2')};
    text-wrap: balance;
    margin-bottom: 1rem;
  }

  p {
    font-size: 0.85rem;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }

  strong {
    font-size: 1.35rem;
    font-weight: normal;
    color: inherit;
  }

  @media (min-width: ${screen('lg')}) {
    text-align: center;

    h1 {
      font-size: ${fontSize('xl4')};
    }
  }
`;

export const Form = {
  Root,
  Intro
};
